import React, { useEffect, useState } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { superadminLogin } from "../store/slices/auth";
import { useNavigate } from "react-router-dom";
import SignupBG from "../assets/img/illustraionImg.png";
import { toast } from "react-hot-toast";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";

export default function SuperAdminLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, error, user } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const [formErrors, setFormErrors] = useState({});

  const validate = (name, value) => {
    if (!value.trim()) {
      if (name === "username") return "Please enter username";
      if (name === "password") return "Please enter password";
    }
    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: validate(name, value) }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = {};
    Object.keys(formData).forEach((key) => {
      const err = validate(key, formData[key]);
      if (err) errors[key] = err;
    });

    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      dispatch(superadminLogin(formData));
    }
  };

  useEffect(() => {
    if (!user) return;

    const role = user?.data?.roleId?.name;

    if (role === "superadmin") {
      navigate("/sadmin/home", { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  }, [user, navigate]);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  return (
    <div className="auth-wrapper">
      <div className="auth-left">
        <div className="mobile-illustration-wrap">
          <img
            src={SignupBG}
            alt="illustration"
            className="auth-illustration"
          />
        </div>
      </div>

      <div className="auth-right">
        <div>
          {" "}
          <h3 className="auth-title">WELCOME</h3>
        </div>
        <Form className="auth-form" onSubmit={handleSubmit}>
          <div>
            <input
              type="text"
              name="username"
              placeholder="Enter username"
              className={`auth-input mb-3 ${formErrors.username ? "input-error" : ""
                }`}
              value={formData.username}
              onChange={handleChange}
            />
            {formErrors.username && (
              <small className="error-text">{formErrors.username}</small>
            )}
          </div>

          <div style={{ position: "relative", marginTop: "5px" }}>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Enter password"
              className={`auth-input ${formErrors.password ? "input-error" : ""
                }`}
              value={formData.password}
              onChange={handleChange}
              style={{ paddingRight: "42px" }}
            />

            <span
              onClick={() => setShowPassword((prev) => !prev)}
              style={{
                position: "absolute",
                right: "14px",
                top: "48%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "#0d05f3",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                userSelect: "none",
              }}
            >
              {showPassword ? (
                <IoIosEye size={20} />
              ) : (
                <IoIosEyeOff size={20} />
              )}
            </span>

            {formErrors.password && (
              <small className="error-text">{formErrors.password}</small>
            )}
          </div>



          <Button className="auth-btn mt-3" type="submit" disabled={loading}>
            {loading ? (
              <>
                <Spinner size="sm" animation="border" /> Logging in...
              </>
            ) : (
              "Login"
            )}
          </Button>
        </Form>
      </div>
    </div>
  );
}
